import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities } from 'redux-modules/entity'

import api from 'api'

const FETCH_REQUEST = 'realhub/agent/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/agent/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/agent/FETCH_FAILURE'

// Initial State
const initialState = {
  creating: false,
  loaded: false,
  loadedForEntities: [],
  loading: false,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loading: true,
    loadedForEntities: payload.loadedForEntities,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    errors: [],
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadAgentsForEntity(entityType, entityId, options){
  const entityKey = `${entityType}${entityId}`
  return (dispatch, getState) => {
    const loadedForEntities = [...getState().agents.loadedForEntities]

    if (!loadedForEntities.includes(entityKey)){
      loadedForEntities.push(entityKey)
    }

    // Set Loading
    dispatch(fetchRequest({ loadedForEntities }))

    const promise = api('/admin/agents.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.AGENT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, result: json }
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForEntities: action.loadedForEntities || state.loadedForEntities,
        loading: action.loading,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: action.loaded,
        loading: action.loading,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        errors: action.errors,
        loaded: action.loaded,
        loading: action.loading,
      }
    default:
      return state
  }
}
